import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../../../API";
import { toast } from "react-toastify";

export const getAllProductsAction = createAsyncThunk(
    "Products/GetAllProducts",
    async (data) => {
        if (data.dataGridDetails) {
            return {
                data: data.dataGridDetails.gridData
            }
        }
        else {
            delete data.dataGridDetails;

            return apiCall("/product/getall", "POST", data, false)
                .then((response) => {
                    if (response.status === 200) {
                        if (!response.data.hasError) {

                            return {
                                ...response.data,
                            }
                        } else {
                            return Promise.reject({
                                ...response.data.message,
                            });
                        }
                    }
                })
                .catch((error) => {
                    return Promise.reject({
                        ...error,
                    });
                });
        }
    }
);

export const getProductAction = createAsyncThunk(
    "Products/GetProduct",
    async (data) => {
        return apiCall("/product/get", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        return {
                            ...response.data,
                        }
                    } else {
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error,
                });
            });
    }
);

export const insertUpdateProductAction = createAsyncThunk(
    "Producst/insertUpdateProduct",
    async (data) => {

        return apiCall("/product/insertupdate", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        let message = response.data.message
                        return {
                            data: {
                                ...response.data,
                            },
                            message: {
                                code: response.data.message.code,
                                type: response.data.message.type,
                                message: response.data.message.message
                            },
                            newRecord: data.id ? false : true
                        }
                    } else {
                        if (!response.data.message && response.data.errors && response.data.errors.length) {
                            response.data.message = response.data.errors[0];
                        }
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
                else {
                    return Promise.reject({
                        ...response.data,
                    });
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error,
                });
            });
    }
);

export const changeStatusProductAction = createAsyncThunk(
    "Products/changeStatusProducts",
    async (data) => {
        return apiCall("/product/changestatus", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        toast.success(response.data.message.message, {
                            position: "bottom-center",
                        });
                        return {
                            ...response.data,
                            data: {
                                ...data,
                            },
                        };
                    } else {
                        toast.error(response.data.message.message, {
                            position: "bottom-center",
                        });
                        return Promise.reject({
                            ...response.data.message,
                        });
                    }
                }
            })
            .catch((error) => {
                toast.error(error, {
                    position: "bottom-center",
                });
                return Promise.reject({
                    ...error,
                });
            });
    }
);
